
import XTable from 'vux/src/components/x-table/index.vue'

export default {
name: 'Mallampati',
components: {
XTable
}
}



// WEBPACK FOOTER //
// ./src/pages/formulas/Anae/Chart_Mallampati.vue